// RunBuka theme
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Edge lamps switch on as they enter view; content reveals with them.
  function observe(selector, cb, margin) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, { rootMargin: margin || '0px 0px -12% 0px', threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  observe('[data-lamp]', function (el) { el.classList.add('is-on'); }, '0px 0px -20% 0px');

  // Show the small header logo only once the large hero logo has scrolled past
  var big = document.querySelector('[data-big-logo]');
  var mini = document.querySelector('[data-mini-logo]');
  var bigVisible = big && getComputedStyle(big).display !== 'none';
  if (mini) {
    if (!bigVisible) { mini.classList.add('is-visible'); }
    else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        mini.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-70px 0px 0px 0px' }).observe(big);
    } else { mini.classList.add('is-visible'); }
  }
  observe('.reveal', function (el) { el.classList.add('is-in'); });

  // Mobile menu: close on outside click
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-menu][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Number(input.value || 1) + Number(b.getAttribute('data-step'));
        input.value = Math.max(Number(input.min || 1), n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery: swipeable track, thumbnails and dots stay in sync
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');

    if (track && slides.length > 1) {
      var current = 0;

      function mark(i) {
        if (i === current) return;
        current = i;
        thumbs.forEach(function (t) {
          var on = Number(t.getAttribute('data-index')) === i;
          t.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        dots.forEach(function (d) {
          d.classList.toggle('is-active', Number(d.getAttribute('data-index')) === i);
        });
      }

      function goTo(i) {
        var slide = slides[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-index'))); });
      });

      // Whichever slide sits closest to the track's centre is the current one
      var tick;
      track.addEventListener('scroll', function () {
        if (tick) window.cancelAnimationFrame(tick);
        tick = window.requestAnimationFrame(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestGap = Infinity;
          slides.forEach(function (s, i) {
            var gap = Math.abs((s.offsetLeft - track.offsetLeft) + s.clientWidth / 2 - mid);
            if (gap < bestGap) { bestGap = gap; best = i; }
          });
          mark(best);
        });
      }, { passive: true });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(current + 1, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(current - 1, 0)); }
      });
    }
  }

  // Product form: variant sync + AJAX add to cart
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
    var radios = form.querySelectorAll('[data-variant-radio]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var btn = form.querySelector('[data-add]');
    var fmt = form.getAttribute('data-money-format') || '{{amount}} TL';
    var money = function (cents) {
      var a = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, a);
    };
    var sync = function () {
      var v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { var on = v.compare_at_price > v.price; compareEl.textContent = on ? money(v.compare_at_price) : ''; compareEl.hidden = !on; }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-soldout'); }
      var url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    radios.forEach(function (r) {
      r.addEventListener('change', function () { idInput.value = r.value; sync(); });
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = btn.getAttribute('data-label-adding');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1) })
      })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = document.querySelector('[data-cart-count]');
          if (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; }
          btn.textContent = btn.getAttribute('data-label-added');
          var note = document.querySelector('[data-added]'); if (note) note.hidden = false;
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.textContent = label; btn.disabled = false; form.submit(); });
    });
    sync();
  }

  // Quick add from a product card, with an orb that flies to the cart
  function bumpCart(count) {
    var c = document.querySelector('[data-cart-count]');
    if (c) { c.textContent = count; c.hidden = count === 0; }
    var cart = document.querySelector('.header__cart');
    if (cart) { cart.classList.remove('is-bump'); void cart.offsetWidth; cart.classList.add('is-bump'); }
  }
  function flyToCart(from) {
    var target = document.querySelector('.header__cart');
    if (!target || reduce) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    var orb = document.createElement('span');
    orb.className = 'fly';
    orb.style.left = (a.left + a.width / 2 - 10) + 'px';
    orb.style.top = (a.top + a.height / 2 - 10) + 'px';
    document.body.appendChild(orb);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = orb.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(1.25)', opacity: .95, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25)', opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.4,.05,.3,1)' });
    anim.onfinish = function () { orb.remove(); };
  }
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      flyToCart(btn);
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.getAttribute('data-quick-add'), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.classList.add('is-added');
          bumpCart(cart.item_count);
          setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 1400);
        })
        .catch(function () { btn.disabled = false; window.location.href = '/cart'; });
    });
  });

  // Cart page: auto-submit on quantity change
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) cartForm.querySelectorAll('input[name="updates[]"]').forEach(function (i) {
    i.addEventListener('change', function () { cartForm.submit(); });
  });
})();
